import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import {Datetime} from 'vue-datetime';

import axios from "axios";

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faEdit,
  faInfo,
  faTrashAlt,
  faUsers,
  faMap,
  faTools,
  faDatabase,
  faChartBar,
  faCarBattery
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import VModal from 'vue-js-modal'
import './registerServiceWorker'

import Highcharts from 'highcharts';

import AlertModal from './plugins/alertModal'

import FlowGrid from 'vue-flow-grid';

import {Tabs, Tab} from 'vue-tabs-component'

// router setup
import routes from './routes/routes'

import './registerServiceWorker'

const https = require('https');

// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(VModal);
Vue.use(Datetime);
Vue.use(Highcharts);
Vue.use(AlertModal);
// Vue.use(window.FlowGrid);
Vue.use(FlowGrid);

library.add(faInfo, faEdit, faTrashAlt, faUsers, faMap, faTools, faDatabase, faChartBar, faCarBattery);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('datetime', Datetime);
Vue.component('chart', Highcharts);

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return {x: 0, y: 0}
    }
  }
});

const agent = new https.Agent({
  rejectUnauthorized: false
});

Vue.prototype.$http = axios.create({
  httpsAgent: agent,
  withCredentials: true,
  // baseURL: 'http://localhost:5000/api/',
  baseURL: 'https://api.ws.infinitecpower.com/api/',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

Vue.prototype.$http.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    router.push('/auth/login');
    localStorage.setItem('isAdmin', null);
    localStorage.setItem('email', null);
  } else if (error.response.status >= 400) {
    console.log(error.response.data);
    alert(error.response.data.error);
  }
  return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  data() {
    return {}
  },
});
